import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { Input, Label } from '@cargomatic/ui';
import unitConverter from 'convert-units';
import { LocaleContext } from 'providers/locale-settings-context';
import { getCurrencySymbol } from 'components/modules/master/formatters';
// Original module referenced an undefined `DEFAULT_CURRENCY`. Pin to USD —
// the codebase displays $ regardless via getCurrencySymbol fallback behavior.
const DEFAULT_CURRENCY = 'USD';
function convert(value, from, to) {
    if (value == null || value === '')
        return '';
    const result = unitConverter(Number(value)).from(from).to(to);
    return Number(result).toFixed(2);
}
function NumberField({ id, label, defaultValue, onChange }) {
    return (React.createElement("div", { className: "space-y-1.5" },
        React.createElement(Label, { htmlFor: id }, label),
        React.createElement(Input, { id: id, type: "number", defaultValue: defaultValue !== null && defaultValue !== void 0 ? defaultValue : '', onChange: (e) => {
                const next = e.target.value;
                onChange(next === '' ? undefined : Number(next));
            } })));
}
export function TariffOtherPropsEditor({ tariff, onChange }) {
    const { t } = useTranslation();
    const { localeData } = useContext(LocaleContext);
    const distanceUnit = (localeData === null || localeData === void 0 ? void 0 : localeData.distance_units) || 'mi';
    const weightUnit = (localeData === null || localeData === void 0 ? void 0 : localeData.weight_units) || 'lb';
    const currency = getCurrencySymbol(DEFAULT_CURRENCY);
    const localMinDistance = convert(tariff.minimum_distance, 'mi', distanceUnit);
    const localMinWeight = convert(tariff.minimum_weight, 'lb', weightUnit);
    const handleDistanceInLocal = (value) => {
        if (value == null) {
            onChange('minimum_distance', undefined);
            return;
        }
        const inMiles = unitConverter(value).from(distanceUnit).to('mi');
        onChange('minimum_distance', Number(inMiles.toFixed(2)));
    };
    const handleWeightInLocal = (value) => {
        if (value == null) {
            onChange('minimum_weight', undefined);
            return;
        }
        const inLbs = unitConverter(value).from(weightUnit).to('lb');
        onChange('minimum_weight', Number(inLbs.toFixed(2)));
    };
    return (React.createElement("div", { className: "grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-x-6 gap-y-4" },
        React.createElement(NumberField, { id: "tariff-min-distance", label: t('MINIMUM_DISTANCE_WITH_UNIT', { distanceUnit }), defaultValue: localMinDistance, onChange: handleDistanceInLocal }),
        React.createElement(NumberField, { id: "tariff-min-weight", label: t('MINIMUM_WEIGHT_WITH_UNIT', { weight_units: weightUnit }), defaultValue: localMinWeight, onChange: handleWeightInLocal }),
        React.createElement(NumberField, { id: "tariff-min-cost", label: t('MINIMUM_COST_WITH_CURRENCY', { currency }), defaultValue: tariff.minimum_cost, onChange: (v) => onChange('minimum_cost', v) }),
        React.createElement(NumberField, { id: "tariff-max-cost", label: t('MAXIMUM_COST_WITH_CURRENCY', { currency }), defaultValue: tariff.maximum_cost, onChange: (v) => onChange('maximum_cost', v) }),
        React.createElement(NumberField, { id: "tariff-cost-per-mile", label: t('COST_PER_EXTRA_DISTANCE', { distanceUnit, currency }), defaultValue: tariff.cost_per_extra_mile, onChange: (v) => onChange('cost_per_extra_mile', v) }),
        React.createElement(NumberField, { id: "tariff-cost-per-lb", label: t('COST_PER_EXTRA_WEIGHT', {
                weight_units: weightUnit,
                currency,
            }), defaultValue: tariff.cost_per_extra_lb, onChange: (v) => onChange('cost_per_extra_lb', v) }),
        React.createElement(NumberField, { id: "tariff-box-to-pallet", label: t('BOX_TO_PALLET_CONVERSION_RATE'), defaultValue: tariff.box_to_pallet_conversion_rate, onChange: (v) => onChange('box_to_pallet_conversion_rate', v) }),
        React.createElement(NumberField, { id: "tariff-fsc", label: t('FSC').toUpperCase(), defaultValue: tariff.fsc, onChange: (v) => onChange('fsc', v) })));
}
export default TariffOtherPropsEditor;
